import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
interface Slide1Props {
  onNext: () => void;
}
export function Slide1({
  onNext
}: Slide1Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." data-id="element-36">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-12 gap-8 items-center" data-id="element-37">
        <div className="col-span-7 space-y-6" data-id="element-38">
          <h1 className="text-5xl font-bold text-white leading-tight" data-id="element-39">
            THE <em className="italic" data-id="element-40">FIRST</em> AND{' '}
            <span className="text-highlight" data-id="element-41">ONLY</span> BIOSPECIFIC ANTIBODY
            TARGETING VEGF-A & ANG-2<sup data-id="element-42">¹</sup>
          </h1>
          <p className="text-xl text-highlight font-bold uppercase tracking-wide" data-id="element-43">
            DESIGNED TO ADDRESS TWO KEY PATHWAYS INVOLVED IN RETINAL VASCULAR
            INSTABILITY
          </p>
          <div className="pt-8" data-id="element-44">
            <Button variant="primary" onClick={onNext} data-id="element-45">
              SEE THE DUAL-TARGET APPROACH
            </Button>
          </div>
        </div>

        <div className="col-span-5 flex flex-col items-center justify-center relative" data-id="element-46">
          {/* Molecule Image - Floating directly on gradient */}
          <div className="relative" data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/tm2Ze3Cc3HAunRqoVV2W7P/Screenshot_2026-02-16_at_17.56.01.png" alt="Bispecific antibody targeting VEGF-A and Anti-Ang-2" className="w-full h-auto max-w-md drop-shadow-2xl mix-blend-multiply" style={{
            mixBlendMode: 'normal'
          }} // Reset blend mode if image has white bg
          data-id="element-48" />

            {/* Labels */}
            <div className="absolute top-0 left-0 -translate-y-4 -translate-x-4" data-id="element-49">
              <span className="text-[#1B3A5C] font-bold text-lg" data-id="element-50">VEGF-A</span>
              <svg className="w-8 h-8 text-[#1B3A5C] rotate-45" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-51">
                <path d="M7 17L17 7M17 7H7M17 7V17" data-id="element-52" />
              </svg>
            </div>

            <div className="absolute top-0 right-0 -translate-y-4 translate-x-4" data-id="element-53">
              <span className="text-[#C8B84D] font-bold text-lg" data-id="element-54">
                Anti-Ang-2
              </span>
              <svg className="w-8 h-8 text-[#1B3A5C] -rotate-45" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-55">
                <path d="M7 17L17 7M17 7H7M17 7V17" data-id="element-56" />
              </svg>
            </div>

            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-8 text-center" data-id="element-57">
              <svg className="w-6 h-6 text-[#1B3A5C] mx-auto -rotate-135" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-58">
                <path d="M7 17L17 7M17 7H7M17 7V17" data-id="element-59" />
              </svg>
              <span className="text-[#1B3A5C] font-bold text-lg block" data-id="element-60">
                Région Fc
              </span>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}